import React from 'react';
import { Field } from 'react-final-form';
import { InputField, SelectField } from '@unite-us/app-components';
import { useIsClientsDrawer } from '../../context/InteractionsContext';
import { FIELD_NAMES, MINUTE_OPTIONS } from '../../constants';

const LABEL_STYLES = `mb-1 block app-components-form-field__label 
  text-xs text-text-blue 
  leading-4 tracking-normal 
  font-proxima font-bold normal-case`;

const getDurationRowClass = (isClientsDrawer) => (
  isClientsDrawer ?
    'grid w-full grid-cols-2 gap-x-4' :
    'grid grid-cols-2 gap-x-4 w-1/2'
);

export function DurationRow() {
  const isClientsDrawer = useIsClientsDrawer();

  return (
    <div className={getDurationRowClass(isClientsDrawer)}>
      <Field name={FIELD_NAMES.hours}>
        {(params) => (
          <InputField
            {...params}
            className="mb-0 min-w-0 w-full"
            id="structured-interaction-hours"
            label="Hours"
            labelClassName={LABEL_STYLES}
            omitLabelStyles
            style={{ input: { height: '40px', minHeight: '40px', boxSizing: 'border-box' } }}
            type="number"
            min={0}
            required
          />
        )}
      </Field>
      <Field name={FIELD_NAMES.minutes}>
        {({ input, meta }) => (
          <SelectField
            className="structured-interactions-field-minutes mb-0"
            data-testid="structured-interaction-minutes"
            id="structured-interaction-minutes"
            invalid={meta.touched && !!meta.error}
            label="Minutes"
            labelClassName={LABEL_STYLES}
            labelKey="label"
            onBlur={input.onBlur}
            onChange={input.onChange}
            options={MINUTE_OPTIONS}
            required
            searchEnabled={false}
            shouldSort={false}
            touched={meta.touched}
            value={input.value}
            valueKey="value"
            error={meta.touched ? meta.error : undefined}
          />
        )}
      </Field>
    </div>
  );
}
